import React from 'react'  
import axios from 'axios'
import LoadingPage from './LoadingPage'
import PollsTable from './PollsTable'
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';


class Hlasovani extends React.Component {  
    constructor(props) {
        super(props);

        const searchParams = new URLSearchParams(window.location.search);

        // data z dynamickych endpointu
        this.sessionResults = this.props.sessionResults;
        this.voteResults = this.props.voteOptions;
        this.members = this.props.memberOptions;
        this.parties = this.props.subjectOptions;
        this.sessions = this.props.sessionOptions;

        let sessionResultValue = searchParams.get("vysledek_hlasovani") || null;
        let voteResultValue = searchParams.get("hlasovaci_moznost") || null;
        let memberValue = searchParams.get("clen") || null;
        let partyValue = searchParams.get("subjekt") || null;
        let sessionValue = searchParams.get("zasedani") || null;
        
        this.state = {
            votesData : undefined,
            checked: (searchParams.get("pouze_platna") === 'true') || null,
            checkedProc: (searchParams.get("neproceduralni") === 'true') || null,
            input: searchParams.get("text") || '',
            view: searchParams.get("pohled") || null,
            sessionResult: sessionResultValue !== null ? this.sessionResults.find(element => element.code === parseInt(sessionResultValue)) : null,
            voteResult: voteResultValue !== null ? this.voteResults.find(element => element.code === parseInt(voteResultValue)) : null,
            member: memberValue !== null ? this.members.find(element => element.code === parseInt(memberValue)) : null,
            party: partyValue !== null ? this.parties.find(element => element.code === parseInt(partyValue)) : null,
            session: sessionValue !== null ? this.sessions.find(element => element.code === parseInt(sessionValue)) : null
        }

        this.componentDidMount = this.componentDidMount.bind(this);

        this.onInputChange = this.onInputChange.bind(this);
        this.onViewChange = this.onViewChange.bind(this);
        this.onValidChange = this.onValidChange.bind(this);
        this.onProcChange = this.onProcChange.bind(this);
        this.onSessionResultChange = this.onSessionResultChange.bind(this);
        this.onVoteResultChange = this.onVoteResultChange.bind(this);
        this.onMemberChange = this.onMemberChange.bind(this);
        this.onPartyChange = this.onPartyChange.bind(this);
        this.onSessionChange = this.onSessionChange.bind(this);
    }

    setParams(key, value) {
        const url = new URL(window.location);
        if (key === 'pohled') {
            // uklid v URL
            url.searchParams.delete('text');
            url.searchParams.delete('vysledek_hlasovani');
            url.searchParams.delete('hlasovaci_moznost');
            url.searchParams.delete('pouze_platna');
            url.searchParams.delete('neproceduralni');
            url.searchParams.delete('clen');
            url.searchParams.delete('subjekt');
            url.searchParams.delete('zasedani');

            // uklid vnitrnich stavu
            this.setState({ input: '' });
            this.setState({ sessionResult: null });
            this.setState({ voteResult: null });
            this.setState({ checked: null });
            this.setState({ checkedProc: null });
            this.setState({ member: null });
            this.setState({ party: null });
            this.setState({ session: null });
        }
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
    }
    
    onInputChange(e) {
        this.setState({input: e.target.value});
        if (e.target.value !== '') {
            // vse ok
            this.setParams('text', e.target.value);
        } else {
            // zruseni filtru
            const url = new URL(window.location);
            url.searchParams.delete('text');
            window.history.pushState({}, '', url);  
        }
    }

    onViewChange(e) {
        this.setState({view: e.value});
        // TODO: show/hide dalsi nabidka
        this.setParams('pohled', e.value);
    }

    onValidChange(e) {
        this.setState({ checked: e.checked });
        if (e.checked === true) {
            this.setParams('pouze_platna', e.checked);
        } else {
            // zruseni filtru
            const url = new URL(window.location);
            url.searchParams.delete('pouze_platna');
            window.history.pushState({}, '', url);
        }
    }

    onProcChange(e) {
        this.setState({ checkedProc: e.checked });
        if (e.checked === true) {
            this.setParams('neproceduralni', e.checked);
        } else {
            // zruseni filtru
            const url = new URL(window.location);
            url.searchParams.delete('neproceduralni');
            window.history.pushState({}, '', url);
        }
    }

    onSessionResultChange(e) {
        this.setState({ sessionResult: e.value });
        this.setParams('vysledek_hlasovani', e.value.code);
    }

    onVoteResultChange(e) {
        this.setState({ voteResult: e.value });
        this.setParams('hlasovaci_moznost', e.value.code);
    }

    onPartyChange(e) {
        this.setState({ party: e.value });
        this.setParams('subjekt', e.value.code);
    }

    onMemberChange(e) {
        this.setState({ member: e.value });
        if (e.value !== undefined) {
            // vse ok
            this.setParams('clen', e.value.code);
        } else {
            // zruseni filtru
            this.setState({ voteResult: null });
            this.setState({ checked: null });
            this.setState({ checkedProc: null });

            const url = new URL(window.location);
            url.searchParams.delete('clen');
            url.searchParams.delete('hlasovaci_moznost');
            url.searchParams.delete('pouze_platna');
            url.searchParams.delete('neproceduralni');
            window.history.pushState({}, '', url);  
        }
    }

    onSessionChange(e) {
        this.setState({ session: e.value });
        if (e.value !== undefined) {
            // vse ok
            this.setParams('zasedani', e.value.code);
        } else {
            // zruseni filtru
            this.setState({ sessionResult: null });
            this.setState({ checked: null });
            this.setState({ checkedProc: null });

            const url = new URL(window.location);
            url.searchParams.delete('zasedani');
            url.searchParams.delete('vysledek_hlasovani');
            url.searchParams.delete('pouze_platna');
            url.searchParams.delete('neproceduralni');
            window.history.pushState({}, '', url);  
        }
    }

    async componentDidMount() {
        let pathNameArr = window.location.pathname.split('/')
        let currentCouncil = pathNameArr[pathNameArr.length-2]
        if ( this.state.votesData === undefined ){
            await axios.get( this.props.apiBaseUrl + currentCouncil + '/votesData').then((response) => {
                this.setState({ votesData: response.data });
            });
        }
    }
    
    render() {
        const { votesData } = this.state;
        const { baseUrl } = this.props;

        if (votesData !== undefined && baseUrl !== undefined) {
            return (
                <div>
                    <div className='m-5 mt-0 mb-0'>
                        <h1 className='text-primary'>Sumarizace hlasování</h1>
                    </div>

                    <div className="surface-0 text-center">
                        <div className="grid">
                            <div className="col-12 md:col-3 mt-3 mb-3 px-5">
                                <span className="p-3 shadow-2 mb-3 flex flex-column justify-content-center" style={{ borderRadius: '10px', width: '90%', margin: 'auto', minHeight: '10rem', minWidth: '10rem' }}>
                                    <i className="pi bi-stack text-2xl text-primary"></i>
                                    <span className='text-2xl text-primary font-semibold'>{ votesData.pocet_hlasovani.toLocaleString('cz') }</span>
                                    <div className="text-900 text-lg mt-2">hlasování (z&nbsp;toho { (votesData.pocet_hlasovani-votesData.pocet_neproceduralnich).toLocaleString('cz') } procedurálních)</div>
                                </span>
                            </div>
                            <div className="col-12 md:col-3 mt-3 mb-3 px-5">
                                <span className="p-3 shadow-2 mb-3 flex flex-column justify-content-center" style={{ borderRadius: '10px', width: '90%', margin: 'auto', minHeight: '10rem', minWidth: '10rem' }}>
                                    <i className="pi bi-check-square text-2xl text-primary"></i>
                                    <span className='text-2xl text-primary font-semibold'>{ votesData.pocet_prijatych.toLocaleString('cz') }</span>
                                    <div className="text-900 text-lg mt-2">přijatých návrhů</div>
                                </span>
                            </div>
                            <div className="col-12 md:col-3 mt-3 mb-3 px-5">
                                <span className="p-3 shadow-2 mb-3 flex flex-column justify-content-center" style={{ borderRadius: '10px', width: '90%', margin: 'auto', minHeight: '10rem', minWidth: '10rem' }}>
                                    <i className="pi bi-x-square text-2xl text-primary"></i>
                                    <span className='text-2xl text-primary font-semibold'>{ votesData.pocet_neprijatych }</span>
                                    <div className="text-900 text-lg mt-2">nepřijatých návrhů</div>
                                </span>
                            </div>
                            <div className="col-12 md:col-3 mt-3 mb-3 px-5">
                                <span className="p-3 shadow-2 mb-3 flex flex-column justify-content-center" style={{ borderRadius: '10px', width: '90%', margin: 'auto', minHeight: '10rem', minWidth: '10rem' }}>
                                    <i className="pi bi-question-square text-2xl text-primary"></i>
                                    <span className='text-2xl text-primary font-semibold'>{ votesData.pocet_neplatnych }</span>
                                    <div className="text-900 text-lg mt-2">neplatných hlasování</div>
                                </span>
                            </div>
                        </div>
                    </div>
 
                    <Divider />

                    <div className='m-5'>
                        <h2 className='text-primary mt-5'>Jednotlivá hlasování</h2> 

                        <div className='filterMenu mb-3 flex flex-column md:flex-row md:justify-content-between'>
                            <div className='flex flex-column lg:flex-row'>
                                <div className="field-radiobutton m-2 lg:ml-0">
                                    <RadioButton inputId="view1" name="view" value="zasedani" onChange={this.onViewChange} checked={this.state.view === 'zasedani'} />
                                    <label htmlFor="view1">Zasedání</label>
                                </div>
                                <div className="field-radiobutton m-2">
                                    <RadioButton inputId="view2" name="view" value="subjekt" onChange={this.onViewChange} checked={this.state.view === 'subjekt'} />
                                    <label htmlFor="view2">Subjekt</label>
                                </div>
                                <div className="field-radiobutton m-2">
                                    <RadioButton inputId="view3" name="view" value="clen" onChange={this.onViewChange} checked={this.state.view === 'clen'} />
                                    <label htmlFor="view3">Člen/ka zastupitelstva</label>
                                </div>
                                <div className="field-radiobutton m-2 ">
                                    <RadioButton inputId="view4" name="view" value="text" onChange={this.onViewChange} checked={this.state.view === 'text'} />
                                    <label htmlFor="view4">Hledaný text v předmětech hlasování</label>
                                </div>
                            </div>
                            <div className='flex flex-column justify-content-center ml-5 md:ml-0 lg:ml-5 mt-5 md:mt-0'>
                                <div className={'mr-3 mb-2 ' + (this.state.view === 'zasedani' ? 'block' : 'hidden')}>
                                    <Dropdown style={{width:"250px"}} value={this.state.session} options={this.sessions} onChange={this.onSessionChange} optionLabel="name" filter showClear filterBy="name" placeholder="Vyberte zasedání" />
                                </div>
                                <div className={'mr-3 mb-2 ' + (this.state.view === 'clen' ? 'block' : 'hidden')}>
                                    <Dropdown style={{width:"250px"}} value={this.state.member} options={this.members} onChange={this.onMemberChange} optionLabel="name" filter showClear filterBy="name" placeholder="Vyberte člena" />
                                </div>
                                <div className={'mr-3 mb-2 ' + (this.state.view === 'subjekt' ? 'block' : 'hidden')}>
                                    <Dropdown style={{width:"250px"}} value={this.state.party} options={this.parties} onChange={this.onPartyChange} optionLabel="name" placeholder="Vyberte subjekt" />
                                </div>
                                <div className={'mr-3 mb-2 ' + (this.state.view === 'zasedani' || this.state.view === 'subjekt'? 'block' : 'hidden')}>
                                    <Dropdown style={{width:"250px"}} value={this.state.sessionResult} options={this.sessionResults} onChange={this.onSessionResultChange} optionLabel="name" placeholder="Vyberte výsledek" />
                                </div>
                                <div className={'mr-3 mb-2 ' + (this.state.view === 'subjekt' || this.state.view === 'clen' ? 'block' : 'hidden')}>
                                    <Dropdown style={{width:"250px"}} value={this.state.voteResult} options={this.voteResults} onChange={this.onVoteResultChange} optionLabel="name" placeholder="Vyberte možnost" />
                                </div>
                                <div className={'mr-3 ' + (this.state.view === 'text' ? 'block' : 'hidden')}>
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText style={{width:"250px"}} value={this.state.input || ''} onChange={this.onInputChange} placeholder="Napište hledaný text" />
                                    </span>
                                </div>
                                <div>
                                    <div className={'field-checkbox mt-3 mr-3 ' + (this.state.view === 'zasedani' ||this.state.view === 'subjekt' || this.state.view === 'clen' ? 'block' : 'hidden')}>
                                        <Checkbox inputId="binary" checked={this.state.checked} onChange={this.onValidChange} />
                                        <label htmlFor="binary">Pouze platná hlasování</label>
                                    </div>
                                    <div className={'field-checkbox mb-3 mr-3 ' + (this.state.view === 'zasedani' ||this.state.view === 'subjekt' || this.state.view === 'clen' ? 'block' : 'hidden')}>
                                        <Checkbox inputId="binary" checked={this.state.checkedProc} onChange={this.onProcChange} />
                                        <label htmlFor="binary">Pouze neprocedurální hlasování</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <PollsTable 
                            baseUrl={ baseUrl } apiBaseUrl={this.props.apiBaseUrl} text={this.state.input} checked={this.state.checked} checkedProc={this.state.checkedProc} view={this.state.view} 
                            sessionResult={this.state.sessionResult} voteResult={this.state.voteResult} member={this.state.member}
                            party={this.state.party} session={this.state.session}
                        />
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingPage />
            );   
        }
    }

}

export default Hlasovani
